import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "checked"
    }}>{`:checked`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v3.0`}</p>
    <p>{`Matches when the selected element is checked. `}</p>
    <p><strong parentName="p">{`See:`}</strong>{` `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/:checked"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/CSS/:checked`}</a></p>
    <p><strong parentName="p">{`Example:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`input:checked {
    background-color: blue;
}
`}</code></pre>
    <h2 {...{
      "id": "quirks-and-exceptions"
    }}>{`Quirks and Exceptions`}</h2>
    <ul>
      <li parentName="ul">{`Only works for `}<inlineCode parentName="li">{`<input type="checkbox">`}</inlineCode>{`. Does not work for Spectrum UXP components or radio buttons. For Spectrum UXP checkboxes, use an attribute selector (e.g., `}<inlineCode parentName="li">{`[checked]`}</inlineCode>{`).`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      